import { gql } from '@apollo/client'

export const CREATE_LOOKUP_TABLE_MUTATION = gql`
  mutation createLookupTable($attributes: LookupTableInput!) {
    createLookupTable(attributes: $attributes) {
      id
      lookupType
      value
      systemValue
      sort
    }
  }
`
